import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

/** Contenedor estándar admin ops — paridad Booking Hub (glass-card + jerarquía título/descripción). */
export function AdminGlassPanel({
  title,
  description,
  children,
  className,
  headerAction,
}: {
  title: string;
  description?: string;
  children: ReactNode;
  className?: string;
  headerAction?: ReactNode;
}) {
  return (
    <div className={cn("glass-card space-y-4 rounded-xl p-4", className)}>
      <div className="flex flex-wrap items-start justify-between gap-2">
        <div>
          <h2 className="text-sm font-semibold text-foreground">{title}</h2>
          {description ? <p className="mt-0.5 text-xs text-muted-foreground">{description}</p> : null}
        </div>
        {headerAction}
      </div>
      {children}
    </div>
  );
}

export const adminStatTileClass =
  "rounded-lg border border-border/60 bg-secondary/15 p-3";
